import React, { useState, useEffect } from "react";
import IconFont from "@/components/icon";
import styles from "./index.module.less";
import { changeEgovUrl } from "@/utils/tools";
import { MenuOutlined, PushpinFilled } from "@/utils/antdIcon";
import TopIcon from "../../TopIcon";

export default function ToolsItem({
  toolsItem,
  isDragging,
  handleBtn,
  isShowDragIcon,
  isShowTopIcon
}: {
  toolsItem: any;
  isDragging?: boolean;
  loading?: boolean;
  handleBtn?: any;
  isShowDragIcon?: boolean;
  isShowTopIcon?: boolean;
}) {
  return (
    <div className={`${styles["right-tools-tiem"]}`}>
      {handleBtn ? (
        <div className={styles["handle_btn"]}>{handleBtn}</div>
      ) : (
        <div className={styles["handle_btn_empty"]} />
      )}
      <div style={{ display: "flex", flex: 1, alignItems: "center" }}>
        {/* 工具图标 */}
        <div className={styles["right-tools-tiem_logo"]}>
          {toolsItem.icon ? (
            <img src={changeEgovUrl(toolsItem.icon)} alt="" />
          ) : (
            <span style={{ fontSize: 22 }}>
              <IconFont type="iconapp_tabbar_application" style={{ color: "#fff" }} />
            </span>
          )}
        </div>
        {/* 工具名称及简述 */}
        <div className={`${styles["right-tools-tiem_info"]} right-tools-tiem_info`}>
          <div className={styles["right-tools-tiem_title"]}>
            <span className={styles["main-title"]}>
              <span className={styles["right-tools-tiem_text"]}>{toolsItem.name}</span>
              {isShowDragIcon ? (
                <MenuOutlined style={{ color: "#BFC1C4", fontSize: "20px" }} />
              ) : (
                ""
              )}
              {isShowTopIcon ? <TopIcon style={{ position: "absolute", right: "-30px" }} /> : ""}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
